import { render, staticRenderFns } from "./BuildRegimen.vue?vue&type=template&id=2f0bc643&scoped=true"
import script from "./BuildRegimen.vue?vue&type=script&lang=js"
export * from "./BuildRegimen.vue?vue&type=script&lang=js"
import style0 from "./BuildRegimen.vue?vue&type=style&index=0&id=2f0bc643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0bc643",
  null
  
)

export default component.exports